import { CompetenzaParcella } from './competenza-parcella';
import { DocumentoAllegato } from './documento-allegato';
import { LegaleIncaricato } from './legale-incaricato';
import { ParcellaSoggetto } from './parcella-soggetto';
import { ScaglioneParcella } from './scaglione-parcella';
import { Cpa } from './tipologiche/cpa';
import { FaseCompensoParcella } from './tipologiche/fase-compenso-parcella';
import { Iva } from './tipologiche/iva';
import { SpesaParcella } from './tipologiche/spesa-parcella';

export class Parcella {
  id: string;
  legale: LegaleIncaricato;
  numeroParcella: string;
  dataParcella: number;
  competenza: CompetenzaParcella;
  scaglione: ScaglioneParcella;
  importoBase: any;
  importoPattuito: any;
  percentualeImportoBase: any;
  flagIva: boolean;
  iva: Iva;
  flagCpa: boolean;
  cpa: Cpa;
  contributoUnificato: any;
  flagRitenutaAcconto: boolean;
  importoParcella: any;
  importoPetitumRiferimento: any;
  spesa: SpesaParcella;
  fasiCompensi: FaseCompensoParcella[];
  note: string;
  documenti: DocumentoAllegato[];
  maggiorazione: number;
  flagParcella: boolean;
  //ripartizione
  parcelleSoggetti: ParcellaSoggetto[];
}
